import FormText from 'components/form/FormText';
import FormWysiwygEditor from 'components/form/FormWysiwygEditor';
import { useFormContext } from 'react-hook-form';
import { useRecoilState } from 'recoil';
import { AcctState } from 'stores/atoms/acctState';
import { DiagnosisEditFormStateType } from 'types/page/diagnosisEditFormStateType';
import { QuizEditFormStateType } from 'types/page/quizEditFormStateType';

/**
 * コンテンツ作成編集 レポートメール設定コンポーネント
 */
export default function WsContentEditReport(props: {
  readOnly: boolean;
  contentCategory: { label: string; value: number };
}): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 型定義 */
  /* ----------------------------------------------------------------------- */
  const [acctState] = useRecoilState(AcctState);

  const formContext = useFormContext();
  let typedFormContext;
  if (props.contentCategory.label === 'クイズ') {
    typedFormContext = formContext as unknown as ReturnType<
      typeof useFormContext<QuizEditFormStateType>
    >;
  } else if (props.contentCategory.label === '診断') {
    typedFormContext = formContext as unknown as ReturnType<
      typeof useFormContext<DiagnosisEditFormStateType>
    >;
  } else {
    throw new Error('無効なコンテンツカテゴリ');
  }
  const {
    control,
    register,
    setValue,
    formState: { errors },
  } = typedFormContext;
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const reportMailSubjectPaceHolder =
    {
      クイズ: '未設定の場合「結果レポート | クイズタイトル」がメールタイトルとして使用されます。',
      診断: '未設定の場合「診断結果 | 診断タイトル」がメールタイトルとして使用されます。',
    }[props.contentCategory.label] || '';

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <section className="section-form-default section-report-mail">
        <div className="container">
          <div className="box-common">
            <h3 className="title-section title-md">レポートメール</h3>

            <div className="form-default-container">
              <div className="form-group">
                <label htmlFor="source-e-mail" className="form-label">
                  メールの件名
                </label>
                <div className="row row-md-8 align-items-center">
                  <div className="col col-form-lg">
                    <FormText
                      name="reportMailSubject"
                      placeholder={reportMailSubjectPaceHolder}
                      register={register}
                      errors={errors}
                      maxLength={100}
                      readOnly={props.readOnly}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="source-e-mail" className="form-label">
                  配信元メールアドレス
                </label>
                <div className="row row-md-8 align-items-center">
                  <div className="col col-form-lg">
                    <FormText
                      name="reportMailSenderAddress"
                      register={register}
                      errors={errors}
                      readOnly={true}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="source-e-mail" className="form-label">
                  返信先メールアドレス
                </label>
                <div className="row row-md-8 align-items-center">
                  <div className="col col-form-lg">
                    <FormText
                      name="reportMailReplyAddress"
                      register={register}
                      errors={errors}
                      readOnly={true}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="distributor-name" className="form-label">
                  配信元の名前
                </label>
                <div className="row row-md-8 align-items-center">
                  <div className="col col-form-lg">
                    <FormText
                      name="reportMailSenderName"
                      placeholder="メール送信元の名前を変更できます。未指定の場合、「BranQ」が送信元名となります。"
                      register={register}
                      errors={errors}
                      maxLength={100}
                      readOnly={props.readOnly}
                    />
                  </div>
                  <div className="col col-btn flex-grow-0 w-auto">
                    <div className="btn-container max-width-130 mt-md-0">
                      <button
                        onClick={() =>
                          setValue('reportMailSenderName', acctState.company.reportMailSenderName)
                        }
                        disabled={props.readOnly}
                        className="btn btn-common moderate-blue w-100"
                      >
                        初期設定に戻す
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="end-report-mail" className="form-label">
                  レポートメール末尾
                </label>
                <div className="row row-md-8">
                  <div className="col col-form-lg">
                    <FormWysiwygEditor
                      control={control}
                      name="reportMailSignatureHtml"
                      placeholder="署名などを入れてください"
                      toolbar={['link']}
                      errors={errors}
                      readOnly={props.readOnly}
                    />
                  </div>
                  <div className="col col-btn flex-grow-0 w-auto">
                    <div className="btn-container max-width-130 mt-md-0">
                      <button
                        onClick={() =>
                          setValue(
                            'reportMailSignatureHtml',
                            acctState.company.reportMailSignatureHtml
                          )
                        }
                        disabled={props.readOnly}
                        className="btn btn-common moderate-blue w-100"
                      >
                        初期設定に戻す
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <br />
          </div>
        </div>
      </section>
    </>
  );
}
